module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_SK-4522aa84efba1ad989404e648fe7ce1a.svg";